import { Policy, PolicyRule } from 'src/types'
import { Option } from 'src/components/Formik/Select'

function airRuleReduce(acc: Option[], cur: PolicyRule): Option[] {
  if (!cur.policy_request_air_rule) {
    return acc
  }

  const text = `${cur.policy_request_air_rule.policy_request_air_rule_prefix}${
    cur.policy_request_air_rule.description
      ? ` - ${cur.policy_request_air_rule.description}`
      : ''
  }`
  return [
    ...acc,
    {
      label: text,
      title: text,
      value: `${cur.policy_request_air_rule.policy_request_air_rule_id}`
    }
  ]
}

export function air(acc: Option[], cur: Policy): Option[] {
  if (!cur.policy_rules.length) {
    return acc
  }
  return [...acc, ...cur.policy_rules.reduce(airRuleReduce, [])]
}

function hotelRuleReduce(acc: Option[], cur: PolicyRule): Option[] {
  if (!cur.policy_request_hotel_rule) {
    return acc
  }

  const text = `${
    cur.policy_request_hotel_rule.policy_request_hotel_rule_prefix
  }${
    cur.policy_request_hotel_rule.description
      ? ` - ${cur.policy_request_hotel_rule.description}`
      : ''
  }`
  return [
    ...acc,
    {
      label: text,
      title: text,
      value: `${cur.policy_request_hotel_rule.policy_request_hotel_rule_id}`
    }
  ]
}

export function hotel(acc: Option[], cur: Policy): Option[] {
  if (!cur.policy_rules.length) {
    return acc
  }
  return [...acc, ...cur.policy_rules.reduce(hotelRuleReduce, [])]
}

function vehicleRuleReduce(acc: Option[], cur: PolicyRule): Option[] {
  if (!cur.policy_request_vehicle_rule) {
    return acc
  }

  const text = `${
    cur.policy_request_vehicle_rule.policy_request_vehicle_rule_prefix
  }${
    cur.policy_request_vehicle_rule.description
      ? ` - ${cur.policy_request_vehicle_rule.description}`
      : ''
  }`
  return [
    ...acc,
    {
      label: text,
      title: text,
      value: `${cur.policy_request_vehicle_rule.policy_request_vehicle_rule_id}`
    }
  ]
}

export function vehicle(acc: Option[], cur: Policy): Option[] {
  if (!cur.policy_rules.length) {
    return acc
  }
  return [...acc, ...cur.policy_rules.reduce(vehicleRuleReduce, [])]
}

function generalRulesReduce(acc: Option[], cur: PolicyRule): Option[] {
  if (!cur.policy_request_general_rule) {
    return acc
  }

  const text = `${cur.policy_request_general_rule.policy_request_rule_prefix}${
    cur.policy_request_general_rule.description
      ? ` - ${cur.policy_request_general_rule.description}`
      : ''
  }`
  return [
    ...acc,
    {
      label: text,
      title: text,
      value: `${cur.policy_request_general_rule.policy_request_general_rule_id}`
    }
  ]
}

export function generalRules(acc: Option[], cur: Policy): Option[] {
  if (!cur.policy_rules.length) {
    return acc
  }

  return [...acc, ...cur.policy_rules.reduce(generalRulesReduce, [])]
}
